export default "__VITE_ASSET__BBHelSGx__"